import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

// ルートパスごとにパネルサイズを保存するatomFamily
export const panelSizesAtomFamily = atomFamily(
  (routePath: string) => atom({
    leftPanel: 30, // デフォルト幅（%）
    rightPanel: 70, // デフォルト幅（%）
  }),
);
